import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex flex-col rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} ${comic.genre}漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs">
          {comic.status}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-background-950/70 text-background-50 text-xs backdrop-blur">
          {comic.genre}
        </span>
        <div className="absolute bottom-0 inset-x-0 h-16 bg-gradient-to-t from-background-950/70 to-transparent"></div>
        <div className="absolute bottom-2 left-3 right-3 flex items-center justify-between text-background-50 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {comic.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400"></i>
            {comic.score.toFixed(1)}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4 flex flex-col flex-1">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <div className="mt-2 flex items-center gap-2 flex-wrap">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs">
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line"></i>
            已更新 {comic.chapters} 话
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {comic.update}
          </span>
        </div>
      </div>
    </Link>
  );
}